export const PIN_CANCELLED_BY_USER_ERROR_STATUS = 'pin cancelled by user'
